/*
 * Copyright (c) Nexign, JSC, 2023.
 */
/**
 *
 *
 * @author Evgeniy Naumov
 * @author Ilya Baranchikov
 * @version 1.26.0
 * @since 1.25.0
 */

import { useMemo } from 'react';

import pick from 'lodash/pick';
import { useSelector } from 'react-redux';

import { FeatureNameEnum } from '@/main/modules/role/constants/guard/guardConstants';
import { ENotificationsSettingsFields } from '@/main/modules/userNotifications/constants';
import {
    makeSelectAuthoritiesIsAssistant,
    makeSelectFeatureEnabled,
} from '@/main/pages/PageAuth/selectors/authSelectors';

import { defaultNotificationsSettingsFormValues } from '../constants';

export const useFormDefaultValues = () => {
    const isAssistant = useSelector(makeSelectAuthoritiesIsAssistant());
    const isNewsFeature = useSelector(makeSelectFeatureEnabled(FeatureNameEnum.NEWS));
    const isCashbackNotificationEnabled = useSelector(makeSelectFeatureEnabled(FeatureNameEnum.CASHBACK_NOTIFICATIONS));

    return useMemo(() => {
        const keysForPick = [
            ENotificationsSettingsFields.showNotifications,
            ENotificationsSettingsFields.showNotificationsOrders,
        ];
        if (isNewsFeature) {
            keysForPick.push(ENotificationsSettingsFields.showNews);
        }
        if (!isAssistant) {
            if (isCashbackNotificationEnabled) {
                keysForPick.push(ENotificationsSettingsFields.showNotificationsCashback);
            }
            keysForPick.push(
                ENotificationsSettingsFields.showNotificationsInquiries,
                ENotificationsSettingsFields.showNotificationsEdo,
            );
        }
        return pick(defaultNotificationsSettingsFormValues, keysForPick);
    }, [isAssistant, isCashbackNotificationEnabled, isNewsFeature]);
};
